import React from "react";
import { connect } from "react-redux";

import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';

import CartInfo from "./components/cart-info";
import Item from "./components/item";
// import { motion, AnimateSharedLayout } from "framer-motion";

import Banner from "../../components/Widgets/Banner";

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    minWidth: 360,
    backgroundColor: theme.palette.background.paper,
    padding: 0,
  },
}));

function Cart (props) {
    const classes = useStyles();
    return (
        <div className="cart">
          <Banner route="cart">
            <CartInfo basket={props.basket} />
          </Banner>
          <div>
            <List className={`cart-items ${classes.root}`}>
                {props?.basket?.map((item, index) => {
                  return <Item key={index} item={item} removeItem={props.removeFromCart} isVisible={true} />
                })}
            </List>
          </div>
        </div>
    )
}

const matchStateToProps = (state) => {
    return {
      basket: state.basket
    }
}

const matchDispatchToProps = (dispatch) => {
    return{
        removeFromCart: (id) => dispatch({type: "REMOVE_FROM_CART", id })
    }
  }

export default connect(matchStateToProps, matchDispatchToProps)(Cart);